import { transform } from "~/features/search/api/fetchAutosuggestions";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function fetchProductSuggestionsForPreview(query: string, abortSignal: AbortSignal) {
  return occFetch(getUrl(query), { signal: abortSignal })
    .then((res) => {
      if (res.redirected) {
        window.location.reload();
      }
      return res.json();
    })
    .then(transform);
}

function getUrl(query: string) {
  const searchParams = new URLSearchParams();
  searchParams.set("site", "schaeffler");

  searchParams.set("q", query);
  searchParams.set("text", query);

  return occUrl(`/search/quick-search?${searchParams.toString()}`);
}
